var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPendulum = function SvgPendulum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.14 20.71"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64 9.12V3.21H.36v11.43M11.79 14.64V.36H7.5v8.76M7.5 14.64V9.12M4.64 9.12v5.52M7.5 14.64a1.43 1.43 0 1 1-2.86 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.36 14.64a5.72 5.72 0 1 0 11.43 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64 14.64a1.43 1.43 0 1 0 2.86 0"
  })))));
};
export default SvgPendulum;